export default "__VITE_ASSET__BUQEPP9I__"